/* RESPONSIBLE TEAM: team-proactive-support */
import { type QueryParamConfig } from '@ember/controller';
import AccountControllerBase from 'embercom/controllers/apps/app/account/base/account-controller-base';

export default class PreferencesController extends AccountControllerBase {
  queryParams: (string | Record<string, string | QueryParamConfig | undefined>)[] = ['highlight'];
  declare model: {};
}
